module.exports = __webpack_public_path__ + "img/text.6f157c0f.png";